import { Box, Typography } from "@mui/material";
import logo from "../../assets/images/logo.png";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        borderTop: "1px solid #e5e7eb",
        backgroundColor: "#ffffff",
        py: { xs: 2, sm: 3.13 },
        px: { xs: 2, sm: 5.63 },
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <img
        src={logo}
        alt="City to City Asia Pacific"
        style={{ height: 25, width: "auto", objectFit: "contain" }}
      />
      <Typography
        sx={{
          fontSize: 12,
          color: "#9ca3af",
          textAlign: { xs: "center", sm: "right" },
        }}
      >
        © 2009-{new Date().getFullYear()}, City To City Asia Pacific LTD. All
        rights reserved
      </Typography>
    </Box>
  );
};

export default Footer;
